import { z } from "zod";
export const colorKeySchema = z.enum([
    "white",
    "cream",
    "pink",
    "coral",
    "red",
    "orange",
    "yellow",
    "green",
    "blue",
    "purple",
    "brown",
    "burgundy",
    "gray",
    "apricot",
    "blush",
    "mixed",
]);
// These are stored in order to render
export const legalColors = [
    {
        name: "White",
        key: "white",
        hexCode: "ffffff",
        isLight: true,
    },
    {
        name: "Cream / Buttercream",
        key: "cream",
        hexCode: "FFFDD0",
        isLight: true,
    },
    {
        name: "Pink",
        key: "pink",
        hexCode: "FFC0CB",
        isLight: true,
    },
    {
        name: "Coral / Salmon",
        key: "coral",
        hexCode: "fa8072",
        isLight: false,
    },
    {
        name: "Red",
        key: "red",
        hexCode: "ff0000",
        isLight: false,
    },
    {
        name: "Orange",
        key: "orange",
        hexCode: "ffa500",
        isLight: false,
    },
    {
        name: "Yellow",
        key: "yellow",
        hexCode: "FFFF00",
        isLight: true,
    },
    {
        name: "Green",
        key: "green",
        hexCode: "00FF00",
        isLight: false,
    },
    {
        name: "Blue / Violet",
        key: "blue",
        hexCode: "0000ff",
        isLight: false,
    },
    {
        name: "Mauve / Purple",
        key: "purple",
        hexCode: "e0b0ff",
        isLight: false,
    },
    {
        name: "Rust / Brown",
        key: "brown",
        hexCode: "A52A2A",
        isLight: false,
    },
    {
        name: "Burgundy / Wine",
        key: "burgundy",
        hexCode: "800020",
        isLight: false,
    },
    {
        name: "Gray",
        key: "gray",
        hexCode: "808080",
        isLight: false,
    },
    {
        name: "Apricot / Peach",
        key: "apricot",
        hexCode: "fbceb1",
        isLight: false,
    },
    {
        name: "Blush / Light Pink",
        key: "blush",
        hexCode: "FFB6C1",
        isLight: false,
    },
    {
        name: "Mixed",
        key: "mixed",
        hexCode: "ffffff",
        isLight: false,
    },
];
export const getColorHexCode = (c_key) => {
    var _a;
    return (_a = legalColors.find((c) => c.key === c_key)) === null || _a === void 0 ? void 0 : _a.hexCode;
};
export const getColorName = (c_key) => {
    var _a;
    return (_a = legalColors.find((c) => c.key === c_key)) === null || _a === void 0 ? void 0 : _a.name;
};
//# sourceMappingURL=colors.js.map